// MAP JS

//////////////////////////////////////////////////////////////////////////////
// Harmony Learning Maps
//////////////////////////////////////////////////////////////////////////////
//////////////////////////////////////////////////////////////////////////////
// Map configuration including styles and icons
//////////////////////////////////////////////////////////////////////////////
var marker_x_size = 50;
var marker_y_size = 50;
var marker_x_center = 25;
var marker_y_center = 25;
var search_type = 'init';
const mapConfig = {
    styles: [{"stylers":[{"hue":"#2c3e50"},{"saturation":250}]},{"featureType":"road","elementType":"geometry","stylers":[{"lightness":50},{"visibility":"simplified"}]},{"featureType":"road","elementType":"labels","stylers":[{"visibility":"off"}]}],
    icons: {
      active: '/wp-content/themes/peha/assets/img/peha-mapicon-active.png',
      inactive: '/wp-content/themes/peha/assets/img/peha-mapicon-inactive.png',
    },
    radius: 15000, // 15 kilometers radius
    enableDebugPins: false, // Toggle for debug pins
    enableOffset: true, // Toggle for map offsetting
    offsetDirection: 'right', // Offset direction ('left' or 'right')
    mediaQueryBreakpoints: {
      576: false, // Disable offset at screen widths >= 576px (sm and below).
      768: false,  // Enable offset at screen widths >= 768px (md).
      992: true,  // Enable offset at screen widths >= 992px (lg).
      1200: true, // Enable offset at screen widths >= 1200px (xl).
      1400: true  // Enable offset at screen widths >= 1400px (xxl).
    },
    // Configuration for the Google Places Autocomplete search box
    placeSearchOptions: {
      // Restrict the autocomplete search to only show region-level results
      types: ['(regions)'], // Restrict the search to regions (localities, suburbs). Can be a single type or an array of types (e.g., '(regions)', 'geocode', 'address', 'establishment', '(cities)')

      // Restrict the autocomplete results to a specific country
      componentRestrictions: {
        country: 'au' // Restrict results to Australia. Can be an array of country codes (e.g., ['us', 'ca'] for the United States and Canada).
      }
    },
    debug: false // Add this line to enable/disable debug logging
  };

  //////////////////////////////////////////////////////////////////////////////
  // Declare map variables in global scope
  //////////////////////////////////////////////////////////////////////////////
  let map;
  let isUsingLocation = false;
  let currentActiveMarker = null;
  let debugPins = [];
  let placeSearch;



  //////////////////////////////////////////////////////////////////////////////
  //////////////////////////////////////////////////////////////////////////////
  // Initialise functions
  //////////////////////////////////////////////////////////////////////////////
  //////////////////////////////////////////////////////////////////////////////
  //////////////////////////////////////////////////////////////////////////////
  // Initialise the map
  // This function initializes the Google Map, sets up the map configuration,
  // and adds event listeners for various map interactions including resizing.
  //////////////////////////////////////////////////////////////////////////////
  function initMap() {
    // Initial center coordinates and zoom level for the map (Brisbane)
    const initialCenter = { lat: -27.468192621607987, lng: 153.02921136765818 };
    const initialZoom = 10;

    // Create a new Google Map instance
    map = new google.maps.Map(document.querySelector('.js-centres-map'), {
      zoom: initialZoom,
      center: initialCenter,
      styles: mapConfig.styles,
      streetViewControl: false,
      mapTypeControl: false,
      fullscreenControl: false,
      scaleControl: false,
      rotateControl: false,
      zoomControl: true,
    });

    // Adjust the initial center to shift markers to the right half of the map
    google.maps.event.addListenerOnce(map, 'bounds_changed', adjustMapCenter);

    // Initialise the Autocomplete for places search
    const input = document.querySelector('.js-place-search');
    placeSearch = new google.maps.places.Autocomplete(input, mapConfig.placeSearchOptions);
    placeSearch.addListener('place_changed', handlePlacesChanged);

    // Listen for the enter key press on the search input field
    input.addEventListener('keydown', function(event) {
      if (event.key === 'Enter') {
        event.preventDefault(); // Prevent the default form submission
        const query = input.value; // Get the value from the input field
        performSearch(query); // Perform the search with the user input
      }
    });

    // Create an InfoWindow for displaying information
    const infoWindow = new google.maps.InfoWindow();

    // Sort centres alphabetically for the initial load
    const sortedCentres = [...mapData.centres].sort((a, b) => a.title.localeCompare(b.title));
    // Create a LatLngBounds instance to fit the map to the markers
    const bounds = new google.maps.LatLngBounds();

    // Iterate through the sorted centres data and create markers
    sortedCentres.forEach(centre => {
      createMarker(centre, infoWindow, bounds);
    });

    // Adjust the map to fit the bounds of the markers
    map.fitBounds(bounds);

    // Add event listeners for map interactions
    google.maps.event.addListener(map, 'bounds_changed', resetLocationButton);
    google.maps.event.addListener(map, 'dragend', updateVisibleCentres); // Update centres on drag end
    google.maps.event.addListener(map, 'zoom_changed', updateVisibleCentres); // Update centres on zoom change

    // Adjust the map center on window resize
    let resizeTimeout;
    let lastWidth = window.innerWidth;

    
    window.addEventListener('resize', () => {
      if (window.innerWidth !== lastWidth) {
        lastWidth = window.innerWidth;
        clearTimeout(resizeTimeout);
        resizeTimeout = setTimeout(() => {
          handleViewAllLocations();
          const bounds = new google.maps.LatLngBounds();

          // Sort centres alphabetically
          const sortedCentres = [...mapData.centres].sort((a, b) => a.title.localeCompare(b.title));

          // Clear the centres list
          updateCentreList([]);

          // Iterate through the sorted centres data and update markers and bounds
          sortedCentres.forEach(centre => {
            if (centre.marker && centre.marker.getMap() === map) {
              bounds.extend(centre.marker.getPosition());
            }
          });

          // Fit the map to the new bounds
          map.fitBounds(bounds);
          adjustMapCenter();

          // Update the centres list with sorted centres
          updateCentreList(sortedCentres);
        }, 100);
      }
    });


    /*
    window.addEventListener('resize', () => {
      if (window.innerWidth !== lastWidth) {
        lastWidth = window.innerWidth;
        clearTimeout(resizeTimeout);
        resizeTimeout = setTimeout(() => {
          console.log(search_type);
          if(search_type == 'places'){
            handlePlacesChanged();
          }else if(search_type == 'all'){
            handleViewAllLocations();
          }else if(search_type == 'mylocation'){
            handleUseMyLocation();
          }
        }, 100);
      }
    });
    */

    // Initialise search from query string if present
    setTimeout(initSearchFromQuery, 1000);

    // Update centre list with sorted centres after a slight delay
    setTimeout(() => {
      updateCentreList(sortedCentres);
    }, 500);
  }

  //////////////////////////////////////////////////////////////////////////////
  // Check if Google Maps API is loaded and initialise the map
  // This function checks if the Google Maps API is loaded and, if so,
  // initialises the map. If the API is not loaded, it retries every second.
  //////////////////////////////////////////////////////////////////////////////
  function checkGoogleMaps() {
    // Check if the Google Maps API is available
    if (typeof google !== 'undefined' && typeof google.maps !== 'undefined') {
      // Google Maps API is loaded, initialise the map
      initMap();
    } else {
      // Google Maps API is not loaded, retry after a delay
      // Retry every second to check if the Google Maps API is loaded
      // console.error('Google Maps API is not loaded, retrying...');
      setTimeout(checkGoogleMaps, 1000);
    }
  }

  //////////////////////////////////////////////////////////////////////////////
  // Initialise DOM-dependent functionality
  // This function sets up event listeners for DOM elements and checks if the
  // Google Maps API is loaded once the DOM content is fully loaded.
  //////////////////////////////////////////////////////////////////////////////
  document.addEventListener('DOMContentLoaded', function() {
    // Add click event listener to the "Use My Location" button
    document.querySelector('.js-use-my-location').addEventListener('click', handleUseMyLocation);

    // Add click event listener to the "View All Locations" button
    document.querySelector('.js-view-all-locations').addEventListener('click', handleViewAllLocations);

    // Add keypress event listener for the "Enter" key on the search input
    document.querySelector('.js-place-search').addEventListener('keypress', function(event) {
      if (event.key === 'Enter') {
        event.preventDefault();
        const query = this.value;
        performSearch(query);
      }
    });

    // Add click event listener for the submit button
    document.querySelector('.js-place-search-submit').addEventListener('click', function(event) {
      event.preventDefault();
      const query = document.querySelector('.js-place-search').value;
      performSearch(query);
    });

    // Check if Google Maps API is loaded and initialise the map
    checkGoogleMaps();

    // Set dynamic height on page load
    setDynamicHeight();

    // Update dynamic height on window resize
    window.addEventListener('resize', setDynamicHeight);
  });


  //////////////////////////////////////////////////////////////////////////////
  // Parse query string and initialise search if present
  //////////////////////////////////////////////////////////////////////////////

  function initSearchFromQuery() {

    // Get URL search parameters
    const urlParams = new URLSearchParams(window.location.search);
    // Retrieve the 'centre_search' parameter value
    const query = urlParams.get('centre_search');
    debugLog("Query from URL:", query);

    // If the query is "all", handle the view all locations logic
    if (query === 'all') {
      handleViewAllLocations();
      setTimeout(scrollToMapSection, 500); // Adjust timeout as necessary
    } else if (query) {

      // Get the search input element
      const searchInput = document.querySelector('.js-place-search');
      // Set the input value to the search query
      searchInput.value = query;
      debugLog("Search input value set to:", searchInput.value);

      // Initialise the Google Places Autocomplete with the input element
      const placeSearch = new google.maps.places.Autocomplete(searchInput, mapConfig.placeSearchOptions);
      debugLog("Autocomplete instance created:", placeSearch);

      // Add an event listener to handle place changes
      placeSearch.addListener('place_changed', handlePlacesChanged);

      // Trigger a simulated search to update the map based on the query
      const service = new google.maps.places.PlacesService(map);
      service.textSearch({ query: query }, function(results, status) {
        if (status === google.maps.places.PlacesServiceStatus.OK) {
          debugLog("PlacesService textSearch results:", results);
          // Set the input value to the first search result's formatted address
          searchInput.value = results[0].formatted_address;
          debugLog("Search input value updated to first result's address:", searchInput.value);

          // Manually set the place details to the Autocomplete instance
          placeSearch.set('place', results[0]);

          // Manually trigger the place_changed event
          google.maps.event.trigger(searchInput, 'place_changed');
        } else {
          console.log("PlacesService textSearch failed with status:", status);
        }
        // Scroll smoothly to the map section after the map updates
        setTimeout(scrollToMapSection, 500); // Adjust timeout as necessary
      });

      // Update display and class on .js-centres-list and .js-centres-listing-wrapper
      document.querySelector('.js-centres-list').style.display = 'block';
      document.querySelector('.js-centres-listing-wrapper').classList.add('h-100');

      // Set dynamic height after updating the display
      setDynamicHeight();
    }
  }




  //////////////////////////////////////////////////////////////////////////////
  //////////////////////////////////////////////////////////////////////////////
  // Event Handlers
  //////////////////////////////////////////////////////////////////////////////
  //////////////////////////////////////////////////////////////////////////////
  //////////////////////////////////////////////////////////////////////////////
  // Handle places changed event for the Autocomplete
  //////////////////////////////////////////////////////////////////////////////
  function handlePlacesChanged() {
    debugLog("Using handlePlacesChanged()");
    debugLog("Autocomplete instance:", this);
    
    // Get the place from the Autocomplete
    const place = this.getPlace();


    debugLog("Place selected from Autocomplete:", place);

    if (!place.geometry) {
      console.log("Returned place contains no geometry");
      return;
    }
    search_type = 'places';
    // Initialise bounds for the new map view
    const bounds = new google.maps.LatLngBounds();

    // Get the user's selected location and create bounds around it
    const userLocation = place.geometry.location;
    const userBounds = new google.maps.Circle({
      center: userLocation,
      radius: mapConfig.radius
    }).getBounds();

    // Clear existing list of centres and reset scroll position
    const centresList = document.querySelector('.js-centres-list');
    centresList.innerHTML = '';
    centresList.scrollTop = 0;

    // Reset the active marker and remove active class from the list
    resetActiveMarker();
    clearDebugPins(); // Clear debug pins

    // Remove existing markers from the map
    mapData.centres.forEach(centre => {
      if (centre.marker) {
        centre.marker.setMap(null);
      }
    });

    // Collect centres within the bounds and calculate their distances from the user location
    const centresWithinBounds = mapData.centres
      .map(centre => {
        const position = new google.maps.LatLng(centre.lat, centre.lng);
        const distance = google.maps.geometry.spherical.computeDistanceBetween(userLocation, position);
        return { ...centre, distance };
      })
      .filter(centre => userBounds.contains(new google.maps.LatLng(centre.lat, centre.lng)));

    // Sort centres by distance from the user location
    centresWithinBounds.sort((a, b) => a.distance - b.distance);

    // Create markers for the sorted centres and extend the map bounds to include them
    centresWithinBounds.forEach(centre => {
      const position = new google.maps.LatLng(centre.lat, centre.lng);
      bounds.extend(position);
      createMarker(centre, null, bounds);
    });

    // Add a debug pin for the searched location
    if (mapConfig.enableDebugPins) {
      createDebugPin(userLocation, mapConfig.icons.debugSearched);
    }

    // Extend the bounds to include the user location for correct fit
    console.log('CNT: '+centresWithinBounds.length);
    if(centresWithinBounds.length < 1 ){ 
      bounds.extend(userLocation);
    }
    
    

    // Adjust the map to fit the new bounds
    map.fitBounds(bounds);
    if(centresWithinBounds.length == 0){ map.setZoom(12); }
    if(centresWithinBounds.length == 1){ map.setZoom(16); }


    // Adjust the map center if offsetting is enabled
    if (mapConfig.enableOffset) {
      adjustMapCenter();
    }

    // Update the centres list with sorted centres
    updateCentreList(centresWithinBounds);

    // Update display and class on .js-centres-list and .js-centres-listing-wrapper
    document.querySelector('.js-centres-list').style.display = 'block';
    document.querySelector('.js-centres-listing-wrapper').classList.add('h-100');

    // Set dynamic height after updating the display
    setDynamicHeight();
  }

  //////////////////////////////////////////////////////////////////////////////
  // Perform search based on user input
  // This function is triggered when the user presses enter in the search box.
  //////////////////////////////////////////////////////////////////////////////
  function performSearch(query) {
    const service = new google.maps.places.PlacesService(map);

    // Perform a text search using Google Places API
    service.textSearch({ query: query }, function(results, status) {
      if (status === google.maps.places.PlacesServiceStatus.OK) {
        debugLog("Text search results:", results);

        // Set the input value to the first result's formatted address
        const input = document.querySelector('.js-place-search');
        input.value = results[0].formatted_address;

        // Manually set the place details to the existing Autocomplete instance
        placeSearch.set('place', results[0]);

        // Manually trigger the place_changed event
        google.maps.event.trigger(input, 'place_changed');
      } else {
        console.log("Text search failed with status:", status);
      }
    });
  }

  //////////////////////////////////////////////////////////////////////////////
  // Handle "Use My Location" functionality
  //////////////////////////////////////////////////////////////////////////////
  function handleUseMyLocation() {
    // Select DOM elements
    const locationStatus = document.querySelector('.js-location-status');
    const locationLoading = document.querySelector('.js-location-loading');
    const useMyLocation = document.querySelector('.js-use-my-location');
    const centresList = document.querySelector('.js-centres-list');
    const searchInput = document.querySelector('.js-place-search');

    // Clear the search input
    searchInput.value = '';

    // Remove the "centre_search" parameter from the URL
    const url = new URL(window.location);
    url.searchParams.delete('centre_search');
    window.history.replaceState({}, '', url);

    // Show loading indicator and hide status and button
    locationLoading.style.display = 'block';
    useMyLocation.style.display = 'none';
    locationStatus.style.display = 'none';

    // Check if geolocation is supported
    if (navigator.geolocation) {
      isUsingLocation = true; // Set the flag for location usage
      navigator.geolocation.getCurrentPosition(position => {
        // Get the user's location
        const userLocation = new google.maps.LatLng(position.coords.latitude, position.coords.longitude);
        const userBounds = new google.maps.Circle({
          center: userLocation,
          radius: mapConfig.radius
        }).getBounds();

        const bounds = new google.maps.LatLngBounds();

        // Clear existing list and reset scroll position
        centresList.innerHTML = '';
        centresList.scrollTop = 0;

        // Reset the active marker and remove active class
        resetActiveMarker();
        clearDebugPins(); // Clear debug pins
        search_type = 'mylocation';

        // Collect centres within the bounds and calculate their distances
        const centresWithinBounds = mapData.centres
          .map(centre => {
            const position = new google.maps.LatLng(centre.lat, centre.lng);
            const distance = google.maps.geometry.spherical.computeDistanceBetween(userLocation, position);
            return { ...centre, distance };
          })
          .filter(centre => userBounds.contains(new google.maps.LatLng(centre.lat, centre.lng)));

        // Sort centres by distance from the user's location
        centresWithinBounds.sort((a, b) => a.distance - b.distance);

        // Create markers for the sorted centres and extend the map bounds to include them
        centresWithinBounds.forEach(centre => {
          const position = new google.maps.LatLng(centre.lat, centre.lng);
          bounds.extend(position);
          createMarker(centre, null, bounds);
        });

        // Create debug pin for "Use My Location" if enabled
        if (mapConfig.enableDebugPins) {
          createDebugPin(userLocation, mapConfig.icons.debugLocation);
        }

        // Adjust the map to fit the new bounds
        map.fitBounds(bounds);
        adjustMapCenter();
        locationLoading.style.display = 'none'; // Hide loading indicator
        locationStatus.style.display = 'block'; // Show location status

        // Delay unsetting the flag to ensure the status remains visible
        setTimeout(() => {
          isUsingLocation = false;
        }, 1000);

        // Update display and class on .js-centres-list and .js-centres-listing-wrapper
        centresList.style.display = 'block';
        document.querySelector('.js-centres-listing-wrapper').classList.add('h-100');

        // Set dynamic height after updating the display
        setDynamicHeight();

      }, () => {
        // Handle error when unable to retrieve location
        locationLoading.style.display = 'none';
        useMyLocation.style.display = 'block';
        alert("Unable to retrieve your location.");
        isUsingLocation = false; // Unset the flag
      });
    } else {
      // Handle case when geolocation is not supported
      locationLoading.style.display = 'none';
      useMyLocation.style.display = 'block';
      alert("Geolocation is not supported by this browser.");
      isUsingLocation = false; // Unset the flag
    }
  }

  //////////////////////////////////////////////////////////////////////////////
  // Handle "View All Locations" functionality
  // This function handles the event when the "View All Locations" button is clicked.
  // It clears the search input, removes the "centre_search" parameter from the URL,
  // and updates the map and centre list to show all locations in alphabetical order.
  //////////////////////////////////////////////////////////////////////////////
  function handleViewAllLocations() {
    // Get references to the centres list and search input elements
    const centresList = document.querySelector('.js-centres-list');
    const searchInput = document.querySelector('.js-place-search');

    // Clear the search input
    searchInput.value = '';
    placeSearch = undefined // clear autocomplete results

    // Remove the "centre_search" parameter from the URL
    const url = new URL(window.location);
    url.searchParams.delete('centre_search');
    window.history.replaceState({}, '', url);

    // Clear existing list of centres and scroll to the top
    centresList.innerHTML = '';
    centresList.scrollTop = 0;

    // Reset the active marker and remove active class from list items
    resetActiveMarker();
    clearDebugPins(); // Clear debug pins
    search_type = 'All';

    // Create a LatLngBounds instance to fit the map to the markers
    const bounds = new google.maps.LatLngBounds();

    // Sort centres alphabetically for displaying all locations
    const sortedCentres = [...mapData.centres].sort((a, b) => a.title.localeCompare(b.title));

    // Iterate through the sorted centres data and create markers
    sortedCentres.forEach(centre => {
      createMarker(centre, new google.maps.InfoWindow(), bounds);
    });

    // Adjust the map to fit the bounds of the markers
    map.fitBounds(bounds);
    adjustMapCenter();

    // Update centre list with sorted centres
    updateCentreList(sortedCentres);

    // Update display and class on .js-centres-list and .js-centres-listing-wrapper
    centresList.style.display = 'block';
    document.querySelector('.js-centres-listing-wrapper').classList.add('h-100');

    // Set dynamic height after updating the display
    setDynamicHeight();

    // Scroll smoothly to the map section after updating the display
    // setTimeout(scrollToMapSection, 500); // Adjust timeout as necessary
  }

  //////////////////////////////////////////////////////////////////////////////
  // Set the active marker
  // This function sets a given marker as the active marker, changing its appearance,
  // and ensuring the associated list item is highlighted. It also repositions the map
  // if necessary to keep the marker within the visible bounds.
  //////////////////////////////////////////////////////////////////////////////
  function setActiveMarker(activeMarker) {
    // Reset the previous active marker to inactive state
    if (currentActiveMarker) {
      currentActiveMarker.setIcon({
        url: mapConfig.icons.inactive, // Set inactive icon
        scaledSize: new google.maps.Size(marker_x_size, marker_y_size), // Size of the inactive icon
        anchor: new google.maps.Point(marker_x_center, marker_y_center)
      });
      currentActiveMarker.setZIndex(null); // Reset zIndex of previous active marker

      // Remove the active class from the previous list item
      const prevActiveListItem = document.querySelector('.js-centres-list .list-group-item.active');
      if (prevActiveListItem) {
        prevActiveListItem.classList.remove('active');
      }
    }

    // Set the new marker to active state
    activeMarker.setIcon({
      url: mapConfig.icons.active, // Set active icon
      scaledSize: new google.maps.Size(marker_x_size, marker_y_size), // Size of the active icon
      anchor: new google.maps.Point(marker_x_center, marker_y_center)
    });
    activeMarker.setZIndex(google.maps.Marker.MAX_ZINDEX + 1); // Bring the marker to the front

    // Ensure the marker is within the right 50% of the map
    const mapBounds = map.getBounds();
    const mapCenter = map.getCenter();
    const mapSpan = mapBounds.toSpan();

    const markerPosition = activeMarker.getPosition();
    const rightBoundaryLng = mapCenter.lng() + mapSpan.lng() / 4; // Define the right 50% boundary

    //if (markerPosition.lng() > rightBoundaryLng || !mapBounds.contains(markerPosition)) {
      // Calculate the new center point to shift the marker to the right 50%
      const viewportWidth = window.innerWidth;
      let newCenter = {
        lat: markerPosition.lat(),
        lng: markerPosition.lng() - mapSpan.lng() / 4
      };
      if(viewportWidth < 992){
        newCenter = {lat: markerPosition.lat(),lng: markerPosition.lng()};
      }
      map.setCenter(newCenter);
    //}

    // Add the active class to the corresponding list item
    const activeListItem = document.querySelector(`.js-centres-list a[data-centre-id="${activeMarker.centreId}"]`);
    if (activeListItem) {
      activeListItem.classList.add('active');
    }

    // Update display and class on .js-centres-list and .js-centres-listing-wrapper
    const centresList = document.querySelector('.js-centres-list');
    const centreListingWrapper = document.querySelector('.js-centres-listing-wrapper');
    if (centresList.style.display !== 'block' || !centreListingWrapper.classList.contains('h-100')) {
      centresList.style.display = 'block';
      centreListingWrapper.classList.add('h-100');
    }

    // Update the current active marker reference
    currentActiveMarker = activeMarker;
  }

  //////////////////////////////////////////////////////////////////////////////
  // Reset the active marker and remove active class from list items
  // This function resets the currently active marker to its inactive state
  // and removes the active class from the corresponding list item.
  //////////////////////////////////////////////////////////////////////////////
  function resetActiveMarker() {
    if (currentActiveMarker) {
      // Set the current active marker to inactive state
      currentActiveMarker.setIcon({
        url: mapConfig.icons.inactive, // Set inactive icon
        scaledSize: new google.maps.Size(marker_x_size, marker_y_size), // Sise of the inactive icon
        anchor: new google.maps.Point(marker_x_center, marker_y_center)
      });
      currentActiveMarker.setZIndex(null); // Reset zIndex of the active marker
      currentActiveMarker = null; // Clear the reference to the active marker
    }

    // Remove the active class from the previously active list item
    const prevActiveListItem = document.querySelector('.js-centres-list .list-group-item.active');
    if (prevActiveListItem) {
      prevActiveListItem.classList.remove('active');
    }
  }

  //////////////////////////////////////////////////////////////////////////////
  // Revert back to "Use My Location" on map interaction
  // This function resets the UI elements related to the "Use My Location"
  // functionality if the user is not currently using the location feature.
  //////////////////////////////////////////////////////////////////////////////
  function resetLocationButton() {
    // Check if the user is not currently using the location feature
    if (!isUsingLocation) {
      // Hide the location status element
      document.querySelector('.js-location-status').style.display = 'none';

      // Hide the location loading indicator
      document.querySelector('.js-location-loading').style.display = 'none';

      // Show the "Use My Location" button
      document.querySelector('.js-use-my-location').style.display = 'block';
    }
  }

  //////////////////////////////////////////////////////////////////////////////
  // Update the visible centres based on map bounds
  //////////////////////////////////////////////////////////////////////////////
  function updateVisibleCentres() {
    const bounds = map.getBounds();
    const centresList = document.querySelector('.js-centres-list');
    centresList.innerHTML = '';
    centresList.scrollTop = 0; // Scroll to the top
    const zoomLevel = map.getZoom();
    // Collect visible centres
    const visibleCentres = mapData.centres.filter(centre =>
      centre.marker && bounds.contains(centre.marker.getPosition())
    );

    // Sort visible centres by proximity to the current map center
    const mapCenter = map.getCenter();
    visibleCentres.sort((a, b) => {
      const distanceA = google.maps.geometry.spherical.computeDistanceBetween(mapCenter, a.marker.getPosition());
      const distanceB = google.maps.geometry.spherical.computeDistanceBetween(mapCenter, b.marker.getPosition());
      return distanceA - distanceB;
    });

    // Add visible centres to the list
    visibleCentres.forEach(centre => addCentreToList(centre, centre.marker));

    /*
    if (zoomLevel < 6) {
      visibleCentres.forEach(centre => 
        centre.marker.setIcon({url: '/wp-content/themes/peha/assets/img/peha-mapicon-inactive.png', scaledSize: new google.maps.Size(39, 39)})
      );
    } else {
      visibleCentres.forEach(centre => 
        centre.marker.setIcon({url: '/wp-content/themes/peha/assets/img/peha-mapicon-inactive.png', scaledSize: new google.maps.Size(53, 53)})
      );
    }
    */

  }




  //////////////////////////////////////////////////////////////////////////////
  //////////////////////////////////////////////////////////////////////////////
  // Utility Functions
  //////////////////////////////////////////////////////////////////////////////
  //////////////////////////////////////////////////////////////////////////////
  //////////////////////////////////////////////////////////////////////////////
  // Debug log function
  //////////////////////////////////////////////////////////////////////////////
  function debugLog(...args) {
    if (mapConfig.debug) {
      console.log(...args);
    }
  }
  //////////////////////////////////////////////////////////////////////////////
  // Set dynamic height for .js-centres-list
  // This function calculates and sets the dynamic height for the centres list
  // based on the available height within the listing wrapper and search elements,
  // taking into account the padding adjustments.
  //////////////////////////////////////////////////////////////////////////////
  function setDynamicHeight() {
    const centresListingColumn = document.querySelector('.js-centres-listing-column');
    const centresListingWrapper = document.querySelector('.js-centres-listing-wrapper');
    const centresSearch = document.querySelector('.js-centres-search');
    const centresList = document.querySelector('.js-centres-list');

    if (centresListingColumn && centresListingWrapper && centresSearch && centresList) {
      // Calculate the padding of the listing column
      const columnStyle = window.getComputedStyle(centresListingColumn);
      const columnPaddingTop = parseFloat(columnStyle.paddingTop);
      const columnPaddingBottom = parseFloat(columnStyle.paddingBottom);
      const columnTotalPadding = columnPaddingTop + columnPaddingBottom;

      // Calculate 25% of the total padding
      const paddingAdjustment = columnTotalPadding * 0.25;

      // Calculate the padding of the listing wrapper
      const wrapperStyle = window.getComputedStyle(centresListingWrapper);
      const paddingTop = parseFloat(wrapperStyle.paddingTop);
      const paddingBottom = parseFloat(wrapperStyle.paddingBottom);
      const totalPadding = paddingTop + paddingBottom;

      // Calculate available height considering the padding and subtracting the padding adjustment
      const availableHeight = centresListingWrapper.clientHeight - centresSearch.clientHeight - totalPadding - paddingAdjustment;

      // Ensure availableHeight is not negative
      const finalHeight = Math.max(availableHeight, 0);

      // Log the calculated values for debugging
      debugLog('Column Padding Top:', columnPaddingTop);
      debugLog('Column Padding Bottom:', columnPaddingBottom);
      debugLog('Column Total Padding:', columnTotalPadding);
      debugLog('Padding Adjustment (25%):', paddingAdjustment);
      debugLog('Wrapper Padding Top:', paddingTop);
      debugLog('Wrapper Padding Bottom:', paddingBottom);
      debugLog('Total Wrapper Padding:', totalPadding);
      debugLog('Available Height:', availableHeight);
      debugLog('Final Height:', finalHeight);

      // Apply the calculated height to the centres list
      centresList.style.height = `${finalHeight}px`;
    }
  }

  //////////////////////////////////////////////////////////////////////////////
  // Create a marker for a centre
  // This function creates a map marker for a given centre, adds it to the map,
  // and includes it in the list of centres.
  //////////////////////////////////////////////////////////////////////////////
  function createMarker(centre, infoWindow, bounds) {
    // Create a LatLng object for the centre's position
    const position = new google.maps.LatLng(centre.lat, centre.lng);

    // Extend the map bounds to include the new position
    bounds.extend(position);

    // Create the marker object
    const marker = new google.maps.Marker({
      position: position, // Set the position of the marker
      map: map, // Associate the marker with the map
      title: centre.title, // Set the title of the marker
      icon: {
        url: mapConfig.icons.inactive, // URL for the marker icon
        scaledSize: new google.maps.Size(marker_x_size, marker_y_size), // Sise of the marker icon
        anchor: new google.maps.Point(marker_x_center, marker_y_center)
      }
    });

    // Store the centre ID in the marker for reference
    marker.centreId = centre.id;

    // Add a click listener to the marker to handle activation and scrolling
    marker.addListener('click', () => {
      setActiveMarker(marker); // Highlight the marker when clicked
      setDynamicHeight();

      const viewportWidth = window.innerWidth; // Get viewport width
      if (viewportWidth < 992) {
        // Get the target element and its offset from the top
        const targetParent = document.querySelector('.js-section-centres-map');
        const targetOffset = targetParent.getBoundingClientRect().top + window.scrollY;
        // Smooth scroll to the target offset
        window.scrollTo({
          top: targetOffset,
          behavior: 'smooth'
        });
        setTimeout(function(){
          scrollToListItem(centre.id); // Scroll to the list item when the marker is clicked
        },600)
      }else{
        scrollToListItem(centre.id); // Scroll to the list item when the marker is clicked
      }
    });
 

    // Store the marker in the centre object for future reference
    centre.marker = marker;

    // Add the centre to the list of centres
    addCentreToList(centre, marker);
  }

  //////////////////////////////////////////////////////////////////////////////
  // Add a centre to the list
  // This function creates a list item for a centre and appends it to the list
  // of centres. It also sets up event listeners for interactions with the list item.
  //////////////////////////////////////////////////////////////////////////////
  function addCentreToList(centre, marker) {

    
      // Create the list item element
      const listItem = document.createElement('a');
      listItem.href = '#'; // Set default href
      listItem.className = 'list-group-item list-group-item-action mt-3 py-4 px-4 rounded-3'; // Set class for styling
      listItem.dataset.centreId = centre.id; // Store the centre ID in a data attribute

      // Set the inner HTML of the list item with centre details and action buttons
      if(!centre.exclude){
        listItem.innerHTML = `
          <div class="d-inline-flex flex-sm-nowrap flex-column flex-md-row w-100">
            <div class="list-group-item-info w-100">
              <h4>${centre.title}</h4>
              <p class="mb-0">${centre.address}</p>
              <a href="https://www.google.com/maps/dir/?api=1&destination=${encodeURIComponent(centre.address)}" target="_blank" class="text-body js-directions-link">Directions</a>
              <p class="mb-0 d-none">Phone: ${centre.phone}</p>
            </div>
            <div class="list-group-item-cta d-flex align-items-end mt-4 mt-md-0">
              <div class="d-grid gap-3">
                <button class="btn btn-secondary js-view-centre" data-href="${centre.link}">Details</button>
                <button class="d-none btn btn-primary-outline js-book-tour" data-href="${centre.link}#mywaitlist-form">Book a Tour</button>
              </div>
            </div>
          </div>
        `;
      }else{
        listItem.innerHTML = `
          <div class="d-inline-flex flex-sm-nowrap flex-column flex-md-row w-100">
            <div class="list-group-item-info w-100">
              <h4>${centre.title}</h4>
              <p class="mb-0">${centre.address}</p>
              <p class="mb-0 d-none">Phone: ${centre.phone}</p>
            </div>
          </div>
        `;
      } // if(!centre.exclude){

      // Add click event listener to the list itemmywaitlist-form
      listItem.addEventListener('click', (event) => {
        const target = event.target;

        // Handle directions link
        if (target.classList.contains('js-directions-link')) {
          return; // Allow default action for directions link
        }

        // Handle view centre button
        if (target.classList.contains('js-view-centre')) {
          event.preventDefault();
          window.location.href = target.getAttribute('data-href');
          return;
        }

        // Handle book tour button
        if (target.classList.contains('js-book-tour')) {
          event.preventDefault();
          window.location.href = target.getAttribute('data-href');
          return;
        }

        // Handle clicking on the list item itself
        event.preventDefault();
        setActiveMarker(marker); // Highlight the marker and list item when clicked
      });

      // Append the list item to the centres list
      document.querySelector('.js-centres-list').appendChild(listItem);
      
  }

  //////////////////////////////////////////////////////////////////////////////
  // Scroll to the list item corresponding to the centre ID
  // This function scrolls the centres list to bring the specified centre's list
  // item into view and highlights it by adding an active class.
  //////////////////////////////////////////////////////////////////////////////
  function scrollToListItem(centreId) {
    // Select the list item corresponding to the centre ID
    const listItem = document.querySelector(`.js-centres-list a[data-centre-id="${centreId}"]`);
    if (listItem) {
      // Add active class to the clicked list item
      listItem.classList.add('active');

      // Select the centres list container
      const centresList = document.querySelector('.js-centres-list');

      // Scroll the list container so that the list item is at the top
      centresList.scrollTop = (listItem.offsetTop - centresList.offsetTop) + 160;
    }
  }

  //////////////////////////////////////////////////////////////////////////////
  // Update the centres list in the DOM
  // This function updates the list of centres displayed on the page by clearing
  // the existing list and then adding the provided centres to the list.
  //////////////////////////////////////////////////////////////////////////////
  function updateCentreList(centres) {
    // Get the reference to the centres list element
    const centresList = document.querySelector('.js-centres-list');

    // Clear existing list of centres
    centresList.innerHTML = '';

    // Iterate through each centre and add it to the list
    centres.forEach(centre => {
      addCentreToList(centre, centre.marker);
    });
  }

  //////////////////////////////////////////////////////////////////////////////
  // Scroll to the map section
  //////////////////////////////////////////////////////////////////////////////
  function scrollToMapSection() {
    // Select the map section and sticky element
    const mapSection = document.querySelector('.js-section-centres-map');
    const stickyElement = document.querySelector('.js-sticky-top');

    // Proceed if the map section exists
    if (mapSection) {
      // Calculate the height of the sticky element, if it exists
      const stickyHeight = stickyElement ? stickyElement.offsetHeight : 0;
      // Additional offset to account for extra spacing
      const additionalOffset = 60;
      // Calculate the top position of the map section, accounting for sticky height and additional offset
      // const mapSectionTop = mapSection.getBoundingClientRect().top + window.scrollY - stickyHeight - additionalOffset;
      const mapSectionTop = mapSection.getBoundingClientRect().top + window.scrollY - additionalOffset;

      // Smoothly scroll to the calculated top position
      window.scrollTo({
        top: mapSectionTop,
        behavior: 'smooth'
      });
    }
  }

  //////////////////////////////////////////////////////////////////////////////
  // Adjust the map center to fit the specified half of the map based on breakpoints
  //////////////////////////////////////////////////////////////////////////////
  function adjustMapCenter() {
    const bounds = map.getBounds();
    if (bounds) {
      const center = bounds.getCenter();
      const span = bounds.toSpan();
      const shouldOffset = mapConfig.enableOffset && shouldEnableOffset();
      const offsetDirection = mapConfig.offsetDirection === 'left' ? 1 : -1;
      const viewportWidth = window.innerWidth; // Get viewport width

      // Calculate the new center point to shift the map center by 1/4 of the map width if offsetting is enabled
      let newCenter = {
        lat: center.lat(),
        lng: shouldOffset ? center.lng() + offsetDirection * (span.lng() / 4) : center.lng() // Apply offset if enabled
      };
      if(viewportWidth < 992){
        newCenter = {lat: center.lat(),lng: center.lng()};
      }


      // Set the new center of the map
      map.setCenter(newCenter);
    } else {
      // If bounds are not yet defined, retry after a short delay
      setTimeout(adjustMapCenter, 100);
    }
  }

  //////////////////////////////////////////////////////////////////////////////
  // Determine if offset should be enabled based on screen width and breakpoints
  // This function checks the current screen width against the defined breakpoints
  // in the mapConfig to decide if the map offset should be enabled.
  //////////////////////////////////////////////////////////////////////////////
  function shouldEnableOffset() {
    const screenWidth = window.innerWidth;

    // Check breakpoints in descending order to apply the correct rule
    const breakpoints = Object.keys(mapConfig.mediaQueryBreakpoints).sort((a, b) => b - a);

    for (const breakpoint of breakpoints) {
      if (screenWidth >= breakpoint) {
        return mapConfig.mediaQueryBreakpoints[breakpoint];
      }
    }

    // If screen width is less than the smallest breakpoint, return false
    return false;
  }

  //////////////////////////////////////////////////////////////////////////////
  // Create a debug pin for visualisation
  // This function creates a debug pin at a given position on the map using the
  // specified icon URL. It adds the debug pin to the map and stores a reference
  // to the debug pin in the debugPins array for future manipulation.
  //////////////////////////////////////////////////////////////////////////////
  function createDebugPin(position, iconUrl) {
    // Create a new marker for the debug pin
    const debugPin = new google.maps.Marker({
      position: position, // Set the position of the debug pin
      map: map, // Associate the debug pin with the map
      icon: {
        url: iconUrl, // URL for the debug pin icon
        scaledSize: new google.maps.Size(30, 30) // Adjust size of the debug pin icon
      }
    });
    // Store reference to the debug pin in the debugPins array
    debugPins.push(debugPin);
  }

  //////////////////////////////////////////////////////////////////////////////
  // Clear debug pins
  // This function iterates over all debug pins stored in the debugPins array
  // and removes them from the map. It then clears the debugPins array to
  // reset the stored references.
  //////////////////////////////////////////////////////////////////////////////
  function clearDebugPins() {
    // Iterate over all debug pins and remove them from the map
    debugPins.forEach(pin => pin.setMap(null));
    // Reset the debugPins array after clearing the pins
    debugPins = [];
  }
